module.exports = __webpack_public_path__ + "img/logo-1-dark.f795b317.svg";